import VisionImage from "../../../images/the-need/vision.jpg";
import DecorationImage from "../../../images/lantern.png";
import en from "../../../locales/en";
import useVisible from "../../../hooks/useVisibility";
import IsPresent from "../../../components/IsPresent";

export default function JourneySection() {
  const data = en["updates-page"]["journey-section"];
  const [ref, isVisible] = useVisible();

  return (
    <div className="relative" ref={ref}>
      <div className="absolute inset-0 bg-white-gradient z-0" />
      <IsPresent data={isVisible}>
        <img src={DecorationImage} alt="Decoration" className="mv-decoration z-10 lg:flex hidden" />
      </IsPresent>
      <img src={VisionImage} className="inset-0 size-full -z-10 absolute object-cover" />

      {/** CONTENT */}
      <div className="px-4 py-10 md:py-20 container mx-auto max-w-screen-2xl relative z-10 text-center flex flex-col gap-8 items-center">
        <div className="white-bg-heading">{data.heading}</div>
        <div className="white-bg-desc max-w-screen-xl">{data.description}</div>
        <div className={`grid md:grid-cols-2 gap-4 w-full max-w-screen-lg ${isVisible && "animate-fade-in"}`}>
          {data["key-areas"].map((areas, index) => {
            return (
              <div key={index} className={`bg-white rounded-lg border-2 border-accent-color p-4 flex flex-col items-center gap-1 shadow-lg ${index === 0 && "lg:col-span-2"}`}>
                <div className="text-lg font-semibold text-accent-color">{areas.heading}</div>
                <div className="text-gray-600">{areas.description}</div>
              </div>
            );
          })}
        </div>
        <div className="white-bg-desc max-w-screen-xl">{data.footer}</div>
      </div>
    </div>
  );
}
